export default "__VITE_ASSET__CkHbtRpm__"